import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import { Layout, Layouts, Responsive, WidthProvider } from "react-grid-layout";
import { v4 as uuidv4 } from "uuid";
import DashboardWidgetTypeEnum from "../../../models/DashboardWidgetTypeEnum";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetDashboardsDTO from "../../../models/DTO/IGetDashboardsDTO";
import IOnGetDashboardsDTO from "../../../models/DTO/IOnGetDashboardsDTO";
import IOnProcessDashboardDTO from "../../../models/DTO/IOnProcessDashboardDTO";
import IProcessDashboardDTO from "../../../models/DTO/IProcessDashboardDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IDashboard from "../../../models/IDashboard";
import IDashboardItem from "../../../models/IDashboardItem";
import ILayoutItem from "../../../models/ILayoutItem";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import SalesTotalTypeEnum from "../../../models/SalesTotalTypeEnum";
import UIService from "../../../services/UIService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { DashboardSidebar } from "../DashboardSidebar/DashboardSidebar";
import { DashboardWidgetItem } from "../DashboardWidgetItem/DashboardWidgetItem";
import { InventoryWidget } from "../InventoryWidget/InventoryWidget";
import { MonthlyOrdersWidget } from "../MonthlyOrdersWidget/MonthlyOrdersWidget";
import MonthlyShipmentsWidget from "../MonthlyShipmentsWidget/MonthlyShipmentsWidget";
import OrdersAtStepWidget from "../OrdersAtStepWidget/OrdersAtStepWidget";
import RecentOrdersWidget from "../RecentOrdersWidget/RecentOrdersWidget";
import { SalesTotalByPeriodWidget } from "../SalesTotalByPeriodWidget/SalesTotalByPeriodWidget";
import { YearlySnapshot } from "../YearlySnapshot/YearlySnapshot";
import * as _ from "lodash-es";
import "./DashboardEditor.scss";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { AccountDetailWidget } from "../AccountDetailWidget/AccountDetailWidget";
import { DashboardRemoteUrlWidget } from "../DashboardRemoteUrlWidget/DashboardRemoteUrlWidget";
import { CreateOrderWidget } from "../CreateOrderWidget/CreateOrderWidget";
import { Socket } from "socket.io-client";
import { FreightPolicyWidget } from "../FreightPolicyWidget/FreightPolicyWidget";
import { SalesSummaryWidget } from "../SalesSummaryWidget/SalesSummaryWidget";
import { DueDateCalendarWidget } from "../DueDateCalendarWidget/DueDateCalendarWidget";
import { SystemMessagesWidget } from "../SystemMessagesWidget/SystemMessagesWidget";
import DashboardTypeEnum from "../../../models/DashboardTypeEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";
import DashboardService from "../../../services/DashboardService";
import {useNavigate} from "react-router-dom";

type Props = {
    vendorModel: IVendorModel;
};

export const DashboardEditor = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const history = useNavigate();

    const getLayoutItemOptions = (): ILayoutItem[] => {
        return [
            { i: DashboardWidgetTypeEnum.MONTHLY_ORDERS, w: 3, h: 4, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.MONTHLY_SHIPMENTS, w: 3, h: 4, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.LAST_YEAR_VOLUME, w: 6, h: 6, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.RECENT_ORDERS, w: 6, h: 6, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.LAST_FIVE_INVENTORY, w: 6, h: 6, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.ORDERS_AT_STEP, w: 2, h: 3, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.DAILY_SALES, w: 2, h: 3, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.WEEKLY_SALES, w: 2, h: 3, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.MONTHLY_SALES, w: 2, h: 3, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.ACCOUNT_DETAIL_LOOKUP, w: 2, h: 3, isResizable: false, x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.REMOTE_URL, w: 2, h: 3, isResizable: true, resizeHandles: ["se"], x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.CREATE_ORDER, w: 2, h: 3, isResizable: true, resizeHandles: ["se"], x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.FREIGHT_POLICY, w: 2, h: 3, isResizable: true, resizeHandles: ["se"], x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.SALES_SUMMARY, w: 6, h: 6, isResizable: true, resizeHandles: ["se"], x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.DUE_DATE_CALENDAR, w: 6, h: 6, isResizable: true, resizeHandles: ["se"], x: 0, y: 0 },
            { i: DashboardWidgetTypeEnum.SYSTEM_MESSAGES, w: 6, h: 6, isResizable: true, resizeHandles: ["se"], x: 0, y: 0 },
        ];
    };

    const getLayout = () => {
        return [
            {
                w: 6,
                h: 6,
                x: 0,
                y: 0,
                i: "last_year_volume-2bdd149a-6944-40ae-b356-0cccf771893a",
                moved: false,
                static: false,
                isDraggable: true,
                isResizable: false,
            },
            {
                w: 2,
                h: 3,
                x: 6,
                y: 0,
                i: "orders_at_step-b6c0f6f5-c088-4318-85ff-48cef4b27673",
                moved: false,
                static: false,
                isDraggable: true,
                isResizable: false,
            },
            {
                w: 2,
                h: 3,
                x: 8,
                y: 0,
                i: "orders_at_step-8e7a4d59-1e3b-4a17-bd65-26b729861c5d",
                moved: false,
                static: false,
                isDraggable: true,
                isResizable: false,
            },
            {
                w: 2,
                h: 3,
                x: 10,
                y: 0,
                i: "orders_at_step-1dd94a59-1a06-42e7-9779-4f3a6b96ab1f",
                moved: false,
                static: false,
                isDraggable: true,
                isResizable: false,
            },
            {
                w: 2,
                h: 3,
                x: 6,
                y: 3,
                i: "daily_sales_total-d619017d-112f-412a-b023-6d083a6223f4",
                moved: false,
                static: false,
                isDraggable: true,
                isResizable: false,
            },
            {
                w: 2,
                h: 3,
                x: 8,
                y: 3,
                i: "weekly_sales_total-9a34b725-bd29-4a2a-adcb-51b055494343",
                moved: false,
                static: false,
                isDraggable: true,
                isResizable: false,
            },
            { w: 2, h: 3, x: 10, y: 3, i: "monthly_sales_total", moved: false, static: false, isDraggable: true, isResizable: false },
        ];
    };

    const crumbs: IBreadcrumbs[] = [
        { title: "dashboard", url: "/dashboard" },
        { title: "dashboard_config", url: "/dashbord/config" },
    ];

    const [layoutItemOptions, setLayoutItemOptions] = useState(getLayoutItemOptions());
    const [isDockVisible, setIsDockVisible] = useState(false);
    const [widgets, setWidgets] = useState<IDashboardItem[]>([]);
    const [layout, setLayout] = useState<Layout[]>(getLayout());
    const [dashboards, setDashboards] = useState<IDashboard[]>([]);
    const [selectedDashboard, setSelectedDashboard] = useState<IDashboard>();
    const [pendingChanges, setPendingChanges] = useState(false);
    const [saveActive, setSaveActive] = useState(false);
    const [initialDashboard, setInitialDashboard] = useState<IDashboard | undefined>();
    const [initialWidgets, setInitialWidgets] = useState<IDashboardItem[] | undefined>();
    const [draggableItem, setDraggableItem] = useState<string | undefined>();
    const [defaultAccountDashboardName, setDefaultAccountDashboardName] = useState<string>("None");
    const [defaultUserDashboardName, setDefaultUserDashboardName] = useState<string>("None");
    const [defaultSupplierDashboardName, setDefaultSupplierDashboardName] = useState<string>("None");

    const getDashboards = () => {
        const payload: IGetDashboardsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            type: [DashboardTypeEnum.CUSTOMER, DashboardTypeEnum.USER, DashboardTypeEnum.SUPPLIER],
        };

        if (!userModel.isSupplierUser) {
            payload.vendorGuid = props.vendorModel.guid;
        }

        socket.emit(EndpointsEnum.DashboardGetDashboards, payload);
    };

    const onGetDashboards = (data: IOnGetDashboardsDTO) => {
        setDashboards(data.dashboards);
    };

    const processDashboard = (deleteFlag?: boolean) => {
        if (selectedDashboard) {
            const payload: IProcessDashboardDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                dashboard: {
                    ...selectedDashboard,
                    config: widgets,
                },
            };

            // need to get if it's the default for the type.
            const isDefaultDashboard = DashboardService.getIsDefaultDashboard(selectedDashboard, supplierModel, userModel);

            payload.isDefaultDashboard = isDefaultDashboard;

            if (deleteFlag) {
                payload.deleteFlag = true;
            }

            socket.emit(EndpointsEnum.DashboardProcessDashboard, payload);

            setSaveActive(true);
            setSelectedDashboard(deleteFlag ? undefined : selectedDashboard);
        }
    };

    const onProcessDashboard = (data: IOnProcessDashboardDTO) => {
        const notification: INotification = {
            message: "successfully_processed_dashboard",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);
        setPendingChanges(false);
        setSaveActive(false);
        setInitialDashboard(data.dashboard);
        setInitialWidgets(data.dashboard.config || []);

        loadUser();
    };

    const loadUser = () => {
        const payload: ILoadUserDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    const onLoadUser = () => {
        getDashboards();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.DashboardOnGetDashboards, fn: onGetDashboards },
        { endpoint: EndpointsEnum.DashboardOnProcessDashboard, fn: onProcessDashboard },
        { endpoint: EndpointsEnum.AppOnLoadUser, fn: onLoadUser },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getDashboards();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        if (dashboards.length) {
            getDefaultInternalUserDashboard();
            getDefaultUserDashboard();
            getDefaultAccountDashboard();
        }
    }, [dashboards]);

    const getGridLayouts = (): Layouts => {
        const lg: Layout = { i: "a", x: 0, y: 0, w: 1, h: 5 };
        const md: Layout = { i: "b", x: 1, y: 0, w: 3, h: 2, minW: 2, maxW: 4 };
        const sm: Layout = { i: "c", x: 4, y: 0, w: 1, h: 2 };

        const layouts: Layouts = {
            lg: [lg],
            md: [md],
            sm: [sm],
        };

        return layouts;
    };

    const onDrop = (_layout: Layout[], item: Layout, e: Event) => {
        const _widgets = widgets;
        // layout.push(item);

        // lookup by the i value
        const index = _layout.length;

        // item.isResizable = false;

        const uuid = uuidv4();

        _widgets.push({
            item,
            allowMultiple: false,
            title: item.i as DashboardWidgetTypeEnum,
            layout_index: `${item.i}-${uuid}`,
            uuid,
            resizeHandles: item.resizeHandles,
        });
        // alert(`Dropped element props:\n${JSON.stringify(item, ['x', 'y', 'w', 'h'], 2)}`);
        // console.log(widgets, item, layout);

        setWidgets(_widgets);
        setLayout(_layout);
        setPendingChanges(true);
        setDraggableItem(undefined);
    };

    const onResize = (
        _layout: Layout[],
        oldItem: Layout,
        newItem: Layout,
        placeholder: Layout,
        event: MouseEvent,
        element: HTMLElement
    ) => {
        // console.log("onResize: ", _layout, oldItem, newItem, placeholder, event, element);

        const _widgets = widgets;

        for (const layoutItem of _layout) {
            for (const widget of _widgets) {
                if (layoutItem.i === widget.layout_index) {
                    widget.item = layoutItem;
                }
            }
        }
    };

    const onDragStop = (
        _layout: Layout[],
        oldItem: Layout,
        newItem: Layout,
        placeholder: Layout,
        event: MouseEvent,
        element: HTMLElement
    ) => {
        // console.log("onDragStop: ", layout, oldItem, newItem, placeholder, event, element);

        const _widgets = widgets;

        for (const layoutItem of _layout) {
            for (const widget of _widgets) {
                if (layoutItem.i === widget.layout_index) {
                    widget.item = layoutItem;
                }
            }
        }

        setWidgets(_widgets);
        setLayout(_layout);
        setPendingChanges(true);
    };

    const getDroppingItem = (): ILayoutItem => {
        const item = layoutItemOptions.find((option) => {
            return option.i === draggableItem;
        })!;
        // let item = { i: 'custom-drop', w: 2, h: 1 };
        // console.log("getDroppingItem: ", item);

        return item;
    };

    const handleDraggableItem = (item: string) => {
        setDraggableItem(item);
        setPendingChanges(true);
    };

    // const getLayoutItem = (widget: IDashboardItem): Layout | ILayoutItem => {
    //     const layouts = layout;
    //
    //     const _layout = layouts.find((item) => {
    //         return item.i === widget.layout_index;
    //     });
    //
    //     // console.log("getLayoutItem", layout);
    //
    //     if (!_layout) {
    //         return widget.item || "";
    //     } else {
    //         return _layout;
    //     }
    // };

    const updateWidgetData = (widgetData: any, widgetUuid: string) => {
        const foundWidget = widgets.find((widget) => {
            return widget.uuid === widgetUuid;
        });

        if (foundWidget) {
            foundWidget.widget_data = widgetData;
        }

        setPendingChanges(true);
    };

    const updateOrdersAtStepForWidget = (order_step_id: number, widget_uuid: string) => {
        const widget = widgets.find((widget) => {
            return widget.uuid === widget_uuid;
        });

        if (widget) {
            widget.widget_data = order_step_id;
        }

        setPendingChanges(true);
    };

    const getLastYearVolumeDetails = (): { orderVolume: any[]; shipmentVolume: any[] } => {
        const orderVolume = [
            { month: 1, order_count: 55 },
            { month: 2, order_count: 65 },
            { month: 3, order_count: 70 },
            { month: 4, order_count: 80 },
            { month: 5, order_count: 85 },
            { month: 6, order_count: 95 },
            { month: 7, order_count: 110 },
            { month: 8, order_count: 120 },
            { month: 9, order_count: 150 },
            { month: 10, order_count: 175 },
            { month: 11, order_count: 190 },
            { month: 12, order_count: 200 },
        ];

        const shipmentVolume = [
            { month: 1, shipment_count: 114 },
            { month: 2, shipment_count: 100 },
            { month: 3, shipment_count: 140 },
            { month: 4, shipment_count: 115 },
            { month: 5, shipment_count: 100 },
            { month: 6, shipment_count: 90 },
            { month: 7, shipment_count: 135 },
            { month: 8, shipment_count: 155 },
            { month: 9, shipment_count: 145 },
            { month: 10, shipment_count: 130 },
            { month: 11, shipment_count: 140 },
            { month: 12, shipment_count: 220 },
        ];

        return { orderVolume, shipmentVolume };
    };

    const getWidget = (widget: IDashboardItem, index: number) => {
        let component: any = null;

        const isMainViewLight = UIService.isMainViewLight();

        switch (widget.title) {
            case DashboardWidgetTypeEnum.MONTHLY_ORDERS:
                component = (
                    <MonthlyOrdersWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        totalMonthlyOrders={1000}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.MONTHLY_SHIPMENTS:
                component = (
                    <MonthlyShipmentsWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        totalMonthlyShipments={1000}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.LAST_YEAR_VOLUME: {
                const lastYearVolumeDetails = getLastYearVolumeDetails();

                component = (
                    <YearlySnapshot
                        key={widget.layout_index}
                        data-grid={widget.item}
                        orderVolume={lastYearVolumeDetails.orderVolume}
                        shipmentVolume={lastYearVolumeDetails.shipmentVolume}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
            }
            break;

            case DashboardWidgetTypeEnum.RECENT_ORDERS: {
                const recentOrders: Partial<IOrder>[] = [
                    {
                        // @ts-expect-error
                        User: { name: "John Doe" },
                        // @ts-expect-error
                        Order_State: { name: "preliminary" },
                        name: "ABC-10000",
                        updated_at: "2000-01-01",
                        // @ts-expect-error
                        Vendor: { name: "Acme, Inc." },
                    },
                ];
                component = (
                    <RecentOrdersWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        recentOrders={recentOrders as IOrder[]}
                        inEditor={true}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                        history={history}
                    />
                );
            }
            break;

            case DashboardWidgetTypeEnum.LAST_FIVE_INVENTORY: {
                const lastFiveStock: Partial<ICatalog_Item>[] = [
                    {
                        name: "Widget",
                        description: "Widget Description",
                        sku: "WIDGET",
                        qty_on_hand: 100,
                        updated_at: "2000-01-01",
                    },
                ];
                component = (
                    <InventoryWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        lastFiveStock={lastFiveStock}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                        isMainViewLight={isMainViewLight}
                    />
                );
            }
            break;

            case DashboardWidgetTypeEnum.ORDERS_AT_STEP:
                component = (
                    <OrdersAtStepWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        socket={socket}
                        notifyFn={uiContext.notifyFn}
                        inEditor={true}
                        updateStepFn={updateOrdersAtStepForWidget}
                        widget={widget}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.ACCOUNT_DETAIL_LOOKUP:
                component = (
                    <AccountDetailWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        socket={socket}
                        notifyFn={uiContext.notifyFn}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.REMOTE_URL:
                component = (
                    <DashboardRemoteUrlWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        socket={socket}
                        notifyFn={uiContext.notifyFn}
                        inEditor={true}
                        updateWidgetFn={updateWidgetData}
                        widget={widget}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.CREATE_ORDER:
                component = (
                    <CreateOrderWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        socket={socket}
                        notifyFn={uiContext.notifyFn}
                        inEditor={true}
                        updateWidgetFn={updateWidgetData}
                        widget={widget}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.DUE_DATE_CALENDAR:
                component = (
                    <DueDateCalendarWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        socket={socket}
                        notifyFn={uiContext.notifyFn}
                        inEditor={true}
                        updateWidgetFn={updateWidgetData}
                        widget={widget}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.SALES_SUMMARY:
                component = (
                    <SalesSummaryWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        socket={socket}
                        notifyFn={uiContext.notifyFn}
                        inEditor={true}
                        updateWidgetFn={updateWidgetData}
                        widget={widget}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.SYSTEM_MESSAGES:
                component = (
                    <SystemMessagesWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                        systemMessages={[]}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.FREIGHT_POLICY:
                component = (
                    <FreightPolicyWidget
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
                break;

            case DashboardWidgetTypeEnum.DAILY_SALES:
            case DashboardWidgetTypeEnum.WEEKLY_SALES:
            case DashboardWidgetTypeEnum.MONTHLY_SALES: {
                let type: SalesTotalTypeEnum = SalesTotalTypeEnum.DAILY;

                let amount = 1000;

                if (widget.title === DashboardWidgetTypeEnum.WEEKLY_SALES) {
                    type = SalesTotalTypeEnum.WEEKLY;
                    amount = 10000;
                } else if (widget.title === DashboardWidgetTypeEnum.MONTHLY_SALES) {
                    type = SalesTotalTypeEnum.MONTHLY;
                    amount = 100000;
                }

                component = (
                    <SalesTotalByPeriodWidget
                        key={widget.layout_index}
                        data-grid={widget.item}
                        type={type}
                        amount={amount}
                        inEditor={true}
                        removeWidget={() => {
                            removeWidget(widget, index);
                        }}
                    />
                );
            }
            break;
        }

        // return component;

        return (
            <div key={`${widget.layout_index}`} data-grid={widget.item}>
                {component}
            </div>
        );
    };

    const removeWidget = (widget: IDashboardItem, index: number) => {
        const _widgets = widgets;

        _widgets.splice(index, 1);

        setWidgets(_widgets);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        if (name === "selectedDashboard") {
            const _dashboards = dashboards;
            let found = false;

            for (const dashboard of _dashboards) {
                if (dashboard.guid === value) {
                    setSelectedDashboard(dashboard);
                    setWidgets(dashboard.config || []);

                    if (initialDashboard?.guid !== dashboard.guid) {
                        setInitialDashboard({ ...dashboard });
                        setInitialWidgets([...dashboard.config]);
                    }

                    found = true;
                    break;
                }
            }

            if (!found) {
                setSelectedDashboard(undefined);
                setWidgets([]);
            }

            setDashboards(_dashboards);
        } else {
            // state[name] = value;
            // state.pendingChanges = true;
            // TODO - Need all the name of handlechange variables / options to change.
        }
    };

    const cancelSidebar = (refresh?: boolean) => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);

        getDashboards();
    };

    const resetChanges = () => {
        if (initialDashboard && initialWidgets) {
            // console.log("reset changes: ", initialDashboard, initialWidgets);

            setPendingChanges(false);
            setSelectedDashboard({ ...initialDashboard });
            setWidgets([...(initialWidgets || [])]);
        }
    };

    const createDashboard = (dashboard?: IDashboard) => {
        const component = <DashboardSidebar cancelFn={cancelSidebar} dashboard={dashboard} />;

        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);
    };

    const getDefaultInternalUserDashboard = () => {
        if (supplierModel.default_dashboard_id) {
            const foundDashboard = dashboards.find((_dashboard) => {
                return _dashboard.id === supplierModel.default_dashboard_id;
            });

            if (foundDashboard) {
                setDefaultSupplierDashboardName(foundDashboard.name);
            }
        }
    };

    const getDefaultAccountDashboard = () => {
        if (supplierModel.default_vendors_dashboard_id) {
            const foundDashboard = dashboards.find((_dashboard) => {
                return _dashboard.id === supplierModel.default_vendors_dashboard_id;
            });

            if (foundDashboard) {
                setDefaultAccountDashboardName(foundDashboard.name);
            }
        }
    };

    const getDefaultUserDashboard = () => {
        if (userModel.supplierUserToken?.default_user_dashboard_id) {
            const foundDashboard = dashboards.find((_dashboard) => {
                return _dashboard.id === userModel.supplierUserToken?.default_user_dashboard_id;
            });

            if (foundDashboard) {
                setDefaultUserDashboardName(foundDashboard.name);
            }
        } else {
            setDefaultUserDashboardName("None");
        }
    };

    const renderDashboardTitle = (dashboard: IDashboard): string => {
        let title = dashboard.name;

        if (dashboard.id === supplierModel.default_dashboard_id) {
            title += ` (Default`;

            if (!supplierModel.default_vendors_dashboard_id) {
                title += " All Users";
            } else {
                title += " Supplier Users";
            }

            title += ")";
        } else if (dashboard.id === supplierModel.default_vendors_dashboard_id) {
            let vendorTitle = "vendor";

            if (supplierModel.vendor_name_override) {
                vendorTitle = supplierModel.vendor_name_override;
            }

            vendorTitle = _.upperFirst(vendorTitle);

            title += ` (Default ${vendorTitle})`;
        } else if (dashboard.id === userModel.supplierUserToken?.default_user_dashboard_id) {
            title += " (Default User)";
        }

        return title;
    };

    const getDefaultDashboardName = () => {
        let name = "None";

        if (userModel.isSupplierUser) {
            if (defaultUserDashboardName !== "None") {
                name = defaultUserDashboardName;
            } else {
                name = defaultSupplierDashboardName;
            }
        }

        // console.log("getDefaultDashboardName: ", name);

        return name;
    };

    const layouts = getGridLayouts();

    const ResponsiveGridLayout = WidthProvider(Responsive);

    return (
        <div className={"DashboardEditor"}>
            <Breadcrumbs crumbs={crumbs} />

            <div className="row">
                <div className={"col-12 d-flex align-items-center"}>
                    <OwTitle title={"dashboard_editor"} leftIconName={"fad fa-th-large"} />

                    <div className={"ms-2"}>
                        <OwButton
                            id={"create"}
                            title={"create"}
                            leftIconClass={"fas fa-plus"}
                            fn={() => {
                                createDashboard();
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className={"d-flex align-items-center mt-2"}>
                <OwLabel title={"current_dashboard"} noBottomMargin={true} className={"me-2"} />
                <OwSelectOption
                    id={"current-dashboard"}
                    className={"w-10r me-2"}
                    name={"selectedDashboard"}
                    fn={handleChange}
                    options={dashboards}
                    selectedOption={selectedDashboard}
                    selectedOptionProp={"guid"}
                    titleRenderFn={renderDashboardTitle}
                    valueProp={"guid"}
                    titleProp={"name"}
                    showBlankFirst={true}
                />
                <div>
                    <OwButton
                        id={"edit"}
                        title={"edit"}
                        leftIconClass={"fad fa-pencil"}
                        fn={() => {
                            createDashboard(selectedDashboard);
                        }}
                        disabled={!selectedDashboard}
                    />

                    <OwButton
                        id={"delete"}
                        title={"delete"}
                        className={"ms-2 btn-danger"}
                        leftIconClass={"fad fa-trash-alt"}
                        fn={() => {
                            processDashboard(true);
                        }}
                        disabled={!selectedDashboard}
                    />
                </div>

                <div className={"ms-auto align-items-end justify-content-end d-flex flex-column"}>
                    {dashboards.length ? (
                        <div>
                            <div className={"justify-content-end text-end"}>
                                <OwLabel title={"your_default_dashboard"} postText={":"} className={"me-2"} isBold={true} />
                                {getDefaultDashboardName()}
                            </div>
                            <div className={"justify-content-end text-end"}>
                                <OwLabel title={"internal_user_default_dashboard"} postText={":"} className={"me-2"} isBold={true} />
                                {defaultSupplierDashboardName}
                            </div>
                            <div className={"justify-content-end text-end"}>
                                <OwLabel
                                    title={"vendor_default_dashboard"}
                                    isSupplierVendorOverride={true}
                                    supplierModel={supplierModel}
                                    postText={":"}
                                    className={"me-2"}
                                    isBold={true}
                                />
                                {defaultAccountDashboardName}
                            </div>
                        </div>
                    ) : null}

                    <div>
                        {pendingChanges ? (
                            <OwLabel
                                leftIconClass={"fad fa-exclamation-triangle"}
                                title={"pending_changes"}
                                noBottomMargin={true}
                                className={"text-danger me-2"}
                            />
                        ) : null}
                        {pendingChanges ? (
                            <OwButton leftIconClass={"fas fa-undo"} title={"reset"} fn={resetChanges} className={"me-2 btn-warning"} />
                        ) : null}
                        <OwButton
                            id={"save"}
                            title={"save"}
                            leftIconClass={"fad fa-save"}
                            fn={() => {
                                processDashboard();
                            }}
                            disabled={!selectedDashboard}
                            active={saveActive}
                        />
                    </div>
                </div>
            </div>

            <div id={"available-widgets"} className={"d-flex flex-column"}>
                <div className={"mt-3 mb-2"}>
                    <OwLabel isUnderline={true} isBold={true} noBottomMargin={true} title={"available_widgets"} className={"me-2"} />
                    (<OwLabel title={"drag_and_drop"} noBottomMargin={true} />)
                </div>

                <div className={"d-flex widget-options"}>
                    {selectedDashboard?.guid ? null : (
                        <div className={"dashboard-widgets-overlay"}>
                            <OwLabel title={"select_a_dashboard_to_edit"} leftIconClass={"fad fa-info-circle text-warning"} />
                        </div>
                    )}
                    <DashboardWidgetItem title={"monthly_orders"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"monthly_shipments"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"last_year_volume"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"recent_orders"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"last_five_inventory"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"orders_at_step"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"daily_sales"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"weekly_sales"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"monthly_sales"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"account_detail_lookup"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"remote_url"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"create_order"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"freight_policy"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"sales_summary"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"due_date_calendar"} dragFn={handleDraggableItem} />
                    <DashboardWidgetItem title={"system_messages"} dragFn={handleDraggableItem} />
                </div>
            </div>

            <div id={"layout-editor"} className={"dashboard grid-wrapper"}>
                <ResponsiveGridLayout
                    className="layout"
                    layouts={layouts}
                    breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                    cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                    rowHeight={50}
                    isBounded={false}
                    isDroppable={true}
                    onDrop={onDrop}
                    onDragStop={onDragStop}
                    onResize={onResize}
                    droppingItem={getDroppingItem()}>
                    {widgets.map((widget, index) => {
                        // let item = this.getLayoutItem(widget);
                        const component = getWidget(widget, index);

                        return component;
                        // return (<div
                        //     key={`${widget.layout_index}`}
                        //     data-grid={widget.item}
                        // >
                        //     {component}
                        // </div>)

                        // return this.getWidget(widget, index);
                    })}
                </ResponsiveGridLayout>
            </div>
        </div>
    );
};
